import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbDateTimeInput } from "abreact/input/date/AbDateTimeInput";
import * as React from "react";
export function AbDateTimeDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-date-time-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  return !viewModel.isEditing ? currentValue != null && props.valueRenderer ? /*#__PURE__*/React.createElement("div", viewModel.readOnlyProps, props.valueRenderer(currentValue)) : /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
    dataTestId: props.dataTestId,
    subject: props.subject,
    accessor: props.accessor,
    currentValue: props.currentValue
  })) : /*#__PURE__*/React.createElement(AbDateTimeInput, _extends({}, viewModel.inputProps, {
    earliestDate: props.earliestDate,
    latestDate: props.latestDate,
    value: currentValue ?? undefined,
    onChange: viewModel.changeValue
  }));
}
//# sourceMappingURL=AbDateTimeDataValueInput.js.map
